import { ComponentProps, MgnlContent } from '@/types';
import { warn } from './LoggerService';

export function buildKey(
  componentContent: MgnlContent | null | undefined
): string {
  return (
    componentContent?.['@path']?.replace(/\//g, '_') ||
    componentContent?.['@name'] ||
    ''
  );
}

export function buildComponentProperties(
  componentContent: MgnlContent | null | undefined,
  passedAttrs: Record<string, unknown> = {},
  index?: number,
  isFallbackComponent?: boolean
): ComponentProps {
  if (!componentContent || typeof componentContent !== 'object') {
    return {};
  }

  const props: ComponentProps = {
    ...passedAttrs,
    metadata: { '@index': index },
    key: buildKey(componentContent),
  };
  let propsContainer: Record<string, unknown>;

  // Wrap all props in the data section if it's a fallback component
  if (isFallbackComponent) {
    props.data = {};
    propsContainer = props.data as Record<string, unknown>;
  } else {
    propsContainer = props;
  }

  Object.keys(componentContent).forEach(key => {
    if (key.match(/^(@|mgnl:|jcr:)/)) {
      props.metadata![key] = componentContent[key];
    } else {
      propsContainer[key.replace('-', '_')] = componentContent[key];
    }
  });

  return props;
}

/*
 * @deprecated use buildComponentProperties instead
 */
export const getComponentProperties = (
  componentContent: MgnlContent,
  index?: number,
  isFallbackComponent?: boolean
): ComponentProps => {
  warn(
    'This getComponentProperties method is deprecated. Use buildComponentProperties instead.'
  );

  return buildComponentProperties(
    componentContent,
    undefined,
    index,
    isFallbackComponent
  );
};
